import { render } from "./ModalAnonymiseAccount.vue?vue&type=template&id=6170c1ee"
import script from "./ModalAnonymiseAccount.vue?vue&type=script&lang=js"
export * from "./ModalAnonymiseAccount.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__